<template>
  <div class="tip-page">
    <div class="tip-page-top">
      <span>{{ data.tipsTitle }}</span>
      <span>
        <i @click="handleCloseTip" class="el-icon-circle-close"></i>
      </span>
    </div>
    <div class="tip-page-content">
      <div
        v-for="(item, index) in data.tipsAttr"
        :key="index"
        class="item-content"
      >
        <label class="item-label">{{ item.label }} ：</label>
        <span class="item-value">{{ item.value }}</span>
      </div>
    </div>
    <div class="tip-page-bottom">
      <el-button type="info" @click="handleOpenVideo('live')"
        >查看视频</el-button
      >
      <el-button type="info" @click="handleOpenVideo('back')"
        >查看录像</el-button
      >
    </div>
    <!-- 图片放大器 -->
    <viewer
      @inited="handleInit"
      :images="viewerPhotos"
      class="viewer"
      ref="viewer"
    >
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
    <miniPlayer
      ref="videoPlayer"
      :x="playerOptions.x"
      v-if="playerOptions.show"
      :y="playerOptions.y"
    ></miniPlayer>
  </div>
</template>

<script>
import miniPlayer from "@components/mini-player/mini-player.vue";
export default {
  name: "tip",
  components: {
    miniPlayer,
  },
  data() {
    return {
      playerOptions: {
        x: 500,
        y: 400,
        show: false,
      },
      viewerPhotos: [],
      viewerInstance: null,
      data: {}, //渲染数据
    };
  },
  methods: {
    //live-直播，back-录像
    handleOpenVideo(type = "live") {
      let item = this.data.attr;
      // console.log(item);
      this.showPlayer = true;
      this.$nextTick(() => {
        this.$refs.videoPlayer.handleClose();
        if (item.thirdDeviceId || item.thirdCameraId) {
          this.$refs.videoPlayer.open({
            playType: type,
            ocxVisible: true,
            cameraCode: item.thirdDeviceId || item.thirdCameraId,
            cameraName: item.deviceName || item.cameraName,
            playBackUrl: "",
            backStartTime: item.startTime || new Date().getTime(), //backVideo起始时间戳
            backEndTime: item.endTime || new Date().getTime(),
            x: 580,
            y: 200,
            z: 100,
          });
        }
      });
    },
    handleShowImg(val) {
      this.viewerPhotos = [val];
      this.viewerInstance.show();
    },
    handleInit(viewer) {
      this.viewerInstance = viewer;
    },
    handleCloseTip() {
      // this.$map.MapInstance2D.removePopup("deviceTip");
      this.$emit("tipClose");
    },
    handleSetData(data) {
      this.data = { ...data };
      console.log("提示窗", this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
.flex-Between {
  display: flex;
  justify-content: space-between;
  //
}
$bgcolor: rgba(30, 40, 64, 1);
.tip-page {
  min-width: 250px;
  height: auto;
  border-radius: 5px;
  //   background: rgba(64, 122, 238, 0.502);
  background: rgba(24, 31, 46, 0.65);
  backdrop-filter: blur(2px);
  &-top {
    background: $bgcolor;
    padding: 12px;
    @extend .flex-Between;
    i {
      font-size: 17px;
      cursor: pointer;
    }
  }
  &-content {
    padding: 0 12px;
    .item-content {
      padding: 5px 0;
      margin: 5px 10px;
      display: flex;
      flex-direction: row;
    }

    .item-label {
      color: #ccc;
      width: 90px;
      margin-right: 10px;
    }
    .item-value {
      max-width: 220px;
    }
  }
  &-bottom {
    background: $bgcolor;
    padding: 5px;
    text-align: center;
  }
}
</style>